import {
	TRANSACTION_CHANNEL,
	TRANSACTION_CREATED,
  TRANSACTION_UPDATED,
  ACCESS_PROVISION_BEGAN,
  BURN_TOKEN_COMPLETED,
  MINT_TOKEN_COMPLETED,
  ACCESS_PROVISION_SUCCESS,
  ACCESS_PROVISION_FAILED
} from "./utils/channel-names";
import type { Events, EventMessage } from "./utils/types.ds";

interface IChannelEvents {
	setNotifications?: (prev) => void;
	userEmail: string;
	setNewNotification?: (val) => void;
}

export default ({
	setNotifications,
	setNewNotification,
	userEmail,
}: IChannelEvents) =>
	[
		{
			channel: `${TRANSACTION_CHANNEL}_${userEmail}`,
			channelEvents: [
				{
					eventName: TRANSACTION_CREATED,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === TRANSACTION_CREATED
							? setNewNotification(data)
							: null;
					},
				},
        {
					eventName: TRANSACTION_UPDATED,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === TRANSACTION_UPDATED
							? setNewNotification(data)
							: null;
					},
				},
        {
					eventName: ACCESS_PROVISION_BEGAN,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === ACCESS_PROVISION_BEGAN
							? setNewNotification(data)
							: null;
					},
				},
        {
					eventName: ACCESS_PROVISION_SUCCESS,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === ACCESS_PROVISION_SUCCESS
							? setNewNotification(data)
							: null;
					},
				},
        {
					eventName: ACCESS_PROVISION_FAILED,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === ACCESS_PROVISION_FAILED
							? setNewNotification(data)
							: null;
					},
				},
        {
					eventName: BURN_TOKEN_COMPLETED,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === BURN_TOKEN_COMPLETED
							? setNewNotification(data)
							: null;
					},
				},
        {
					eventName: MINT_TOKEN_COMPLETED,
					callback: (data: EventMessage) => {
						const newNotification = createNotficationMessage(data);
						setNotifications((prev) => [{ ...newNotification }, ...prev]);
						data.event === MINT_TOKEN_COMPLETED
							? setNewNotification(data)
							: null;
					},
				},
			],
		}
	] as Events[];

const formatTransactionAmount = (amount: string) => amount ? Number.parseInt(amount) / 100 : 0

export const createNotficationMessage = (data: EventMessage) => {
  const eventStatus = data?.status === 'SUCCESSFUL' ? 'Successful' : data?.status === 'FAILED' ? 'Failed' : 'Pending'
	const eventTitleMap = {
    "createTransaction": `Transfer Initiated: ${formatTransactionAmount(data?.amount)} BYDC transfer initiated`,
    "updateTransaction": `Transfer Completed: ${formatTransactionAmount(data?.amount)} BYDC transfer ${eventStatus}`,
    "accessProvisioningBegan": "Processing Access Request",
    "accessProvisioningSuccess": "Access Request Approved",
    "accessProvisioningFailed": "Access Request Failed",
    "mintToken": `Mint Token Completed: ${data?.amount} BYDC minted`,
    "burnToken": `Burn Token Completed: ${data?.amount} BYDC burned`,
  }
  const eventTitle = eventTitleMap[data.event]

	return {
		id: +Date.now(),
		title: eventTitle,
		description: "",
		read: false,
	};
};
